import { atom, useAtom } from "jotai";
import { PriceListItem } from "types";

export type PriceListItemsState = {
  activeItem: PriceListItem | null;
};

type UsePriceListStateReturn = {
  priceListState: PriceListItemsState;
  setPriceListState: React.Dispatch<React.SetStateAction<PriceListItemsState>>;
};

export const allPriceListsAtom = atom<PriceListItem[]>([]);

export const priceListStateAtom = atom<PriceListItemsState>({
  activeItem: null,
});

export const usePriceListState = (): UsePriceListStateReturn => {
  const [priceListState, setPriceListState] = useAtom(priceListStateAtom);

  return { priceListState, setPriceListState };
};
